import ImagesAuthenticationCommonAppleLoginSvg from '@/public/images/authentication/common/apple-login.svg';
import ImagesAuthenticationCommonGoogleLoginSvg from '@/public/images/authentication/common/google-login.svg';
import ImagesAuthenticationCommonSpiritoryLogoSvg from '@/public/images/authentication/common/spiritory-logo.svg';

export {
  ImagesAuthenticationCommonAppleLoginSvg,
  ImagesAuthenticationCommonGoogleLoginSvg,
  ImagesAuthenticationCommonSpiritoryLogoSvg,
};
